<template>
  <div class="home-wrap">
    <div class="padding-12-15 padding-b-30">
      <div class="title-text">资金明细</div>
      <div class="search-wrap">
        <div class="form-item">
          <el-col :span="12">
            <el-select v-model="searchForm.type" placeholder="事件类型" style="width: 165px;">
              <el-option v-for="item in type_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-select v-model="searchForm.is_income" placeholder="收入类型" style="width: 165px;">
              <el-option v-for="item in is_income_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </div>
        <div class="form-item">
          <div class="date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.start_time" @blur.native @focus="showDatePicker('startTime')"  placeholder="选择日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.start_time" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.start_time')">
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.end_time" @blur.native @focus="showDatePicker('endTime')" placeholder="选择日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.end_time" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.end_time')">
            </el-col>
          </div>
          <van-popup v-model="isPopShow" position="bottom" round>
            <van-datetime-picker
              v-model="startTime"
              type="date"
              :max-date="currentTime"
              :formatter="formatter"
              :visible-item-count="5"
              v-if="datePicker == 'startTime'"
              title='请选择开始时间'
              @cancel="cancelPicker"
              @confirm="confirmPicker"
              show-toolbar
            />
            <van-datetime-picker
              v-model="endTime"
              type="date"
              :min-date="startTime"
              :max-date="currentTime"
              :formatter="formatter"
              :visible-item-count="5"
              v-if="datePicker == 'endTime'"
              title='请选择结束时间'
              @cancel="cancelPicker"
              @confirm="confirmPicker"
              show-toolbar
            />
          </van-popup>
        </div>
        <div class="search-box">
          <span class="search-btn" @click="handleFilter">查询</span>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15 padding-b-8">
      <div class="title-text">资金列表</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="明细时间" width="100">
            <template slot-scope="{row}">
              <span>{{ row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="事件类型" width="100">
            <template slot-scope="{row}">
              <span>{{ row.type_str }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="date" label="明细说明" width="100">
            <template slot-scope="{row}">
              <span>{{ row.mingxi_detail }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="date" label="订单号" width="120">
            <template slot-scope="{row}">
              <span>{{ row.relation_id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="变动金额" width="110">
            <template slot-scope="{row}">
              <span>{{ row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="变动后余额" width="110">
            <template slot-scope="{row}">
              <span>{{ row.after_amount }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pagesize" @pagination="getList" />
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '@/components/Pagination' // secondary package based on el-pagination
  import { getDate } from '@/utils/date'
  import { getUserBalanceList } from '@/api/user'
  export default {
    name: 'PromotionMoney',
    components:{
      Pagination
    },
    data () {
      return {
        currentTime: new Date(), // 开始时间不能超过当前时间
        startTime: new Date(), // 开始时间
        endTime: new Date(), // 结束时间
        datePicker: '', // 用于判断哪个选择器的显示与隐藏
        isPopShow: false, // 弹出层隐藏与显示
        listLoading: false,
        list:[],
        total:0,
        searchForm: {
          page: 1,
          pagesize: 10,
          is_income: undefined,
          type: undefined,
          start_time: undefined,
          end_time: undefined,
          sort: '-id'
        },
        is_income_list: [
          { value: '', label: '全部' },
          { value: '1', label: '收入' },
          { value: '2', label: '支出' }
        ],
        type_list: []
      }
    },
    created() {
      this.getList(true)
    },
    methods:{
      getList(first = false){
        this.listLoading = true
        if(first) this.searchForm.page = 1
        let searchForm = Object.assign({}, this.searchForm)
        getUserBalanceList(searchForm).then((response) => {
          this.listLoading = false
          if(response.code != 200){
            this.$toast.fail(response.msg)
            return
          }
          this.list = response.data.list
          this.total = response.data.total
          this.type_list = response.data.type_list
        }).catch(error => {
          this.listLoading = false
          console.log(error)
        })
      },
      handleFilter(){
        this.getList(true)
      },
      showDatePicker(picker) { //弹出层并显示时间选择器
        this.isPopShow = true;
        this.datePicker = picker;
      },
      cancelPicker() { // 选择器取消按钮点击事件
        this.isPopShow = false;
        this.datePicker = "";
      },
      confirmPicker(value) {// 确定按钮，时间格式化并显示在页面上
        var date = value;
        var m = date.getMonth() + 1;
        var d = date.getDate();
        if (m >= 1 && m <= 9) {
          m = "0" + m;
        }
        if (d >= 0 && d <= 9) {
          d = "0" + d;
        }
        var timer = date.getFullYear() + "-" + m + "-" + d
        if(this.datePicker == 'startTime'){
          this.searchForm.start_time = timer;
        }else{
          this.searchForm.end_time = timer;
        }
        this.isPopShow = false;
        this.datePicker = "";
      },
      formatter(type, value) {// 格式化选择器日期
        if (type === "year") {
          return `${value}年`;
        } else if (type === "month") {
          return `${value}月`;
        }
        return value;
      },
      //清除文本框
      clear(val) {
        if(val.indexOf(".") > -1){
          let varArr = val.split(".")
          this[varArr[0]][varArr[1]] = ''
        }else{
          this[val] = ''
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap{
    font-family: Alibaba-PuHuiTi-R;
    .search-wrap{
      overflow: hidden;
      color: #666666;
      .form-item {
        padding-top: 8px;
        overflow: hidden;
        .choose-time{
          height: 44px;
          border: 1px solid #E8E8E8;
          vertical-align: middle;
          display: flex;
          align-items: center;
          padding-left: 15px;
          padding-right: 10px;
          .time-input{
            border: none;
            outline: none;
            border-radius: 2px;
          }
          .line{
            text-align: center;
            color: #999999;
          }
        }
      }
      .form-item-tip {
        margin-right: 10px;
      }
      .search-box{
        padding: 30px 35px 0 35px;
        padding: 30px 35px 0 35px;
        .search-btn {
          display: block;
          height: 35px;
          line-height: 35px;
          background: #FF8622;
          border-radius: 20px;
          color: #FFFFFF;
          font-size: 14px;
          cursor: pointer;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/money/Index.vue